import styled from 'styled-components'

export const SectionTitleV2 = styled.h2`
  font-family: 'Proxima Nova', sans-serif;
  color: #011533;
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  margin-top: ${props => (props.marginTop ? '40px' : 0)};
`
